export const packages = [

      {
        title: 'Digital-Paket',
        description: 'Ideal wenn keine Ausdrucke benötigt werden.',
        features: [
          'Einfache Bedienung mittels Touchscreen',
          'Unbegrenzte digitale Fotos',
          'Digitale Galerie mit Download',
          'digitales Teilen der Fotos',
          'Requisiten-Set',
          'Auf-/Abbau inklusive'
        ],
        price: 'ab 199 €',
        isPopular: false
      },
      {
        title: 'Premium-Paket',
        description: 'Das Rundum-sorglos-Paket für Ihre Veranstaltung.',
        features: [
          'Einfache Bedienung mittels Touchscreen',
          'Hochwertige Fotobox mit DSLR',
          'Bis zu 400 Ausdrucke',
          'Requisitenpaket',
          'Individuelles Layout',
          'Digitale Galerie mit Download',
          'digitales Teilen der Fotos',
          'Auf-/Abbau inklusive'
        ],
        price: 'ab 299 €',
        isPopular: true
      },
      {
        title: 'Standard-Paket',
        description: 'Am besten geeignet für Feiern bis zu 50 Personen.',
        features: [
          'Hochwertige Fotobox mit DSLR',
          'Einfache Bedienung mittels Touchscreen',
          'Bis zu 200 Ausdrucke',
          'Requisitenpaket',
          'Individuelles Layout',
          'Digitale Galerie mit Download',
          'digitales Teilen der Fotos',
          'Auf-/Abbau inklusive'
        ],
        price: 'ab 269 €',
        isPopular: false
      }
    ]

export function getPackages() {
  return packages
}
